export default __webpack_public_path__ + "static/media/Aeternity.8069b2b1.png";